module.exports = __webpack_public_path__ + "img/zu3.f9507208.png";